import { render, staticRenderFns } from "./SharedVideoView.vue?vue&type=template&id=30a258ff&"
import script from "./SharedVideoView.vue?vue&type=script&lang=js&"
export * from "./SharedVideoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports